const initialState = {
    editing : false,
    editingId : '',
    products : {
    },
    orders : {
    },
    homepage : {
        histories : null,
        articles : null,
        mains : null,
        introductions : null,
        cases : null,
        constructions : null,
        materials : null,
        fertilizers : null,
        mediums : null,
        extras : null,
        cards : null,
    },
    accounts : {
    },
    contact : {
    },
}

const adminReducer = (state = initialState, action) => {
    switch(action.type){
        case 'EDIT_PRODUCT' : {
            return {
                ...state,
                editing : true,
                editingId : action.payload.id
            }
        }break;
        case 'UPDATE_CHECKED_ORDERS' : {
            return {
                ...state,
                orders : {
                    ...state.orders,
                    ids: action.payload.ids
                }
            }
        }break;
        case 'UPDATE_CHECKED_ACCOUNTS' : {
            return {
                ...state,
                accounts : {
                    ...state.acounts,
                    ids: action.payload.ids
                }
            }
        }break;
        case 'UPDATE_CHECKED_CONTACTS' : {
            return {
                ...state, 
                contact : {
                    ...state.contact,
                    ids : action.payload.ids
                }
            }
        }break;

        case 'ADMIN_HISTORIES_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    histories : action.payload.histories
                }
            }
        }break;
        case 'ADMIN_MAINS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    mains : action.payload.mains
                }
            }
        }break;
        case 'ADMIN_INTRODUCTIONS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    introductions : action.payload.introductions
                }
            }
        }break;
        case 'ADMIN_CASES_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    cases : action.payload.cases
                }
            }
        }break;
        case 'ADMIN_CONSTRUCTIONS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : { ...state.homepage, constructions : action.payload.constructions }
            }
        }break;
        case 'ADMIN_MATERIALS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : { ...state.homepage, materials : action.payload.materials }
            }
        }break;
        case 'ADMIN_FERTILIZERS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : { ...state.homepage, fertilizers : action.payload.fertilizers }
            }
        }break;
        case 'ADMIN_MEDIUMS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : { ...state.homepage, mediums : action.payload.mediums }
            }
        }break;
        case 'ADMIN_EXTRAS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : { ...state.homepage, extras : action.payload.extras }
            }
        }break;
        case 'ADMIN_DEPARTMENT_CARDS_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage: { ...state.homepage, cards: action.payload.cards }
            }

        }break;
        case 'ADMIN_ARTICLES_LOAD_SUCCESS' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    articles : action.payload.articles
                }
            }
        }break;
        case 'NEW_EMPTY_ARTICLE_ADDED' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    newArticleId : action.payload.id
                }
            }
        }break;
        case 'ADD_NEW_ARTICLE_SUCCESS' : {
            return {
                ...state,
                homepage : {
                    ...state.homepage,
                    newArticleId : 0
                }
            }
        }break;
        case 'CONTACTS_LOAD_SUCCESS' : {
            return {
                ...state,
                contact : {
                    ...state.contact,
                    contacts : action.payload.contacts
                }
            }
        }break;
        default : {
            return state;
        }break;
    }
}

export default adminReducer;


// WEBPACK FOOTER //
// ./src/reducers/adminReducer.js